import { render, staticRenderFns } from "./DataCardSet.vue?vue&type=template&id=0b907dae&scoped=true"
import script from "./DataCardSet.vue?vue&type=script&lang=js"
export * from "./DataCardSet.vue?vue&type=script&lang=js"
import style0 from "./DataCardSet.vue?vue&type=style&index=0&id=0b907dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b907dae",
  null
  
)

export default component.exports